const pad = (value) => String(value).padStart(2, "0");

export const normalizeAuditTimestamp = (timestamp) => {
  if (!timestamp) {
    return null;
  }

  if (Array.isArray(timestamp)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = timestamp;
    return `${pad(day)}-${pad(month)}-${year} ${pad(hour)}:${pad(minute)}:${pad(second)}`;
  }

  if (typeof timestamp === "object" && timestamp !== null) {
    const {
      year,
      monthValue,
      month,
      dayOfMonth,
      day,
      hour = 0,
      minute = 0,
      second = 0,
    } = timestamp;
    const resolvedMonth = monthValue ?? month;
    const resolvedDay = dayOfMonth ?? day;
    if (year && resolvedMonth && resolvedDay) {
      return `${pad(resolvedDay)}-${pad(resolvedMonth)}-${year} ${pad(hour)}:${pad(
        minute
      )}:${pad(second)}`;
    }
  }

  return String(timestamp);
};

const inferAuditType = (record) => {
  const explicit = record?.auditType || record?.audit_type;
  if (explicit) {
    return String(explicit).toUpperCase();
  }

  const fieldName = String(record?.fieldName || record?.field_name || "").toUpperCase();
  if (fieldName === "DESTINATION_PINCODE") {
    return "DESTINATION_PINCODE";
  }
  if (fieldName === "TRAVEL_BY") {
    return "TRAVEL_BY";
  }

  if (record?.bookedValue != null || record?.auditedValue != null || fieldName) {
    return fieldName || "FIELD";
  }

  return "WEIGHT";
};

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? value : parsed;
};

export const normalizeAuditRecord = (record) => {
  if (!record || typeof record !== "object") {
    return record;
  }

  const auditType = inferAuditType(record);

  return {
    ...record,
    auditType,
    auditMethod: record.auditMethod ?? record.audit_method ?? null,
    auditedHubName: record.auditedHubName ?? record.audited_hub_name ?? null,
    auditTimestamp: normalizeAuditTimestamp(
      record.auditTimestamp ?? record.audit_timestamp
    ),
    bookedValue: record.bookedValue ?? record.booked_value ?? null,
    auditedValue: record.auditedValue ?? record.audited_value ?? null,
    fieldName: record.fieldName ?? record.field_name ?? null,
    valueType: record.valueType ?? record.value_type ?? null,
    bookedWeight: toNumber(record.bookedWeight ?? record.booked_weight),
    auditedWeight: toNumber(record.auditedWeight ?? record.audited_weight),
    bookedLength: toNumber(record.bookedLength ?? record.booked_length),
    auditedLength: toNumber(record.auditedLength ?? record.audited_length),
    bookedWidth: toNumber(record.bookedWidth ?? record.booked_width),
    auditedWidth: toNumber(record.auditedWidth ?? record.audited_width),
    bookedHeight: toNumber(record.bookedHeight ?? record.booked_height),
    auditedHeight: toNumber(record.auditedHeight ?? record.audited_height),
    volumetricBookedValue:
      record.volumetricBookedValue ?? record.volumetric_booked_value ?? null,
    volumetricAuditedValue:
      record.volumetricAuditedValue ?? record.volumetric_audited_value ?? null,
    sourceHubName: record.sourceHubName ?? record.source_hub_name ?? null,
  };
};

export const normalizeAuditList = (auditEvents) => {
  if (!Array.isArray(auditEvents)) {
    return [];
  }
  return auditEvents.map(normalizeAuditRecord);
};
